import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import tagline from 'src/assets/new-landing/cl_tagline_red.svg'
import styles from './login.module.css'
// import { useSettings } from 'cng-web-lib'

export const Footer = ({ showServerInfo }) => {
  // const { saveSettings } = useSettings()

  // const handleChangeLanguage = (language) => {
  //   saveSettings({ language })
  // }

  return <Box component='footer' className={styles.Footer} mt={{ xs: 2, md: 0 }} >
    {/* <Stack direction='row' gap='1rem' justifyContent='center'>
      <Link variant='caption' className={styles.Note}
        title="Switch to English" sx={{ cursor: 'pointer' }}
        onClick={() => handleChangeLanguage('en')}
      >English</Link>
      <Link variant='caption' className={styles.Note}
        title="Traduire en Français" sx={{ cursor: 'pointer' }}
        onClick={() => handleChangeLanguage('fr')}
      >Français</Link>
      <Link variant='caption' className={styles.Note}
        title="Traducir al Español" sx={{ cursor: 'pointer' }}
        onClick={() => handleChangeLanguage('es')}
      >Español</Link>
    </Stack> */}
    <div className={[styles.Tagline, styles.mobile].join(' ')}>
      <img src={tagline} alt="Simpler trade. Smarter tech." />
    </div>
    <Typography variant='footer' component='div' className={styles.Privacy}>
      <div>
        <Link id="copyright" className={styles.Note} title="Opens Crimsonlogic.com in a new tab" href="https://www.crimsonlogic.com"
          target="_blank" rel='noopener noreferrer'>
          Copyright &copy; {new Date().getFullYear()} CrimsonLogic Pte Ltd
        </Link>
        {showServerInfo && <>
          <span className={styles.Note}>|</span>
          <span className={styles.Note}>(server-xx)</span>
        </>}
      </div>
      <div>
        <Link id="privacyPolicy" className={styles.Note} title="Opens our Privacy Policy in a new tab"
          href="https://www.crimsonlogic.com/privacy-policy" target="_blank" rel='noopener noreferrer'>
          Privacy Policy
        </Link>
        <span className={styles.Note}>&#x2022;</span>
        <Link id="termsOfUse" className={styles.Note} title="Opens our Terms of Use in a new tab"
          href="https://www.crimsonlogic.com/terms-use" target="_blank" rel='noopener noreferrer'>
          Terms of Use
        </Link>
        <span className={styles.Note}>&#x2022;</span>
        <Link id="servicesTerms" className={styles.Note} title="Opens our SAAS General Terms and Conditions in a new tab"
          href="https://www.crimsonlogic.com/saas-general-terms-and-conditions" target="_blank" rel='noopener noreferrer'>
          Services T&C
        </Link>
      </div>
    </Typography>
  </Box>
}